import React from 'react';
import { openAuthenticatedUrl } from '@ecs-uk/web-common-mobile-view-helpers';
import benefitsDocument from '../../../../constants/benefitsDocument';
import { TextLinkExternalStyled } from './index.styles';

export const getFactSheetUrl = (family: string): string => {
  const document = (benefitsDocument as Record<string, string>)[family];
  return document ? `${benefitsDocument.baseUrl}/${document}` : benefitsDocument.baseUrl;
};

interface AccountDetailsLinkProps {
  href: string;
  underlineAlways?: boolean;
  isWebview?: boolean;
  planName?: string;
}

const AccountDetailsLink: React.FC<AccountDetailsLinkProps> = ({
  href,
  underlineAlways = false,
  isWebview = false,
  planName,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isWebview) {
      return;
    }

    event.preventDefault();
    openAuthenticatedUrl(new URL(href));
  };

  return (
    <TextLinkExternalStyled
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      $underlineAlways={underlineAlways}
      onClick={handleClick}
      aria-label={planName ? `${planName} full account details. Opens in a new window.` : undefined}
    >
      Full account details
    </TextLinkExternalStyled>
  );
};

export default AccountDetailsLink;
